/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { Oas30MediaType } from '../../openapi/v3/models/Oas30MediaType';
import { SetExampleCommand } from './SetExampleCommand';

/**
 * @author eric.wittmann@gmail.com
 * @extends SetExampleCommand
 * @class
 */
export class SetExampleCommand_30 extends SetExampleCommand {
    public _newExampleName : string;

    public _nullExample : boolean;

    public constructor(parent? : any, example? : any, exampleName? : any) {
        if(((parent != null && parent instanceof <any>Oas30MediaType) || parent === null) && ((example != null) || example === null) && ((typeof exampleName === 'string') || exampleName === null)) {
            let __args = arguments;
            super(parent, example);
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._nullExample===undefined) this._nullExample = false;
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._nullExample===undefined) this._nullExample = false;
            (() => {
                this._newExampleName = exampleName;
            })();
        } else if(parent === undefined && example === undefined && exampleName === undefined) {
            let __args = arguments;
            super();
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._nullExample===undefined) this._nullExample = false;
            if(this._newExampleName===undefined) this._newExampleName = null;
            if(this._nullExample===undefined) this._nullExample = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[SetExampleCommand_30] Executing.");
        this._oldValue = null;
        this._nullExample = false;
        let mediaType : Oas30MediaType = <Oas30MediaType>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(mediaType)) {
            return;
        }
        if(!this.isNullOrUndefined(this._newExampleName)) {
            if(this.isNullOrUndefined(mediaType.getExample(this._newExampleName))) {
                mediaType.addExample(mediaType.createExample(this._newExampleName));
                this._nullExample = true;
            } else {
                this._oldValue = mediaType.getExample(this._newExampleName).value;
            }
            mediaType.getExample(this._newExampleName).value = this._newExample;
        } else {
            this._oldValue = mediaType.example;
            mediaType.example = this._newExample;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[SetExampleCommand_30] Reverting.");
        let mediaType : Oas30MediaType = <Oas30MediaType>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(mediaType)) {
            return;
        }
        if(!this.isNullOrUndefined(this._newExampleName)) {
            if(this._nullExample) {
                mediaType.removeExample(this._newExampleName);
            } else {
                mediaType.getExample(this._newExampleName).value = this._oldValue;
            }
        } else {
            mediaType.example = this._oldValue;
            this._oldValue = null;
        }
    }
}
SetExampleCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.SetExampleCommand_30";
SetExampleCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




